import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PosterImgContainer = styled.div`
  margin-top: 6.7px;
  margin-left: 9px;
  height: 383.4px;
  width: 182.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const StyledImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const BoothPullUpBanner = ({ pullUpBanner, setShowBannerModal }) => (
  <PosterImgContainer onClick={() => setShowBannerModal(true)}>
    <StyledImg src={pullUpBanner} />
  </PosterImgContainer>
);

BoothPullUpBanner.propTypes = {
  pullUpBanner: PropTypes.string.isRequired,
  setShowBannerModal: PropTypes.func.isRequired,
};

export default BoothPullUpBanner;
